import MinusIconButton from './MinusIconButton'
import PlusIconButton from './PlusIconButton'

const buttonSx = {
  borderRadius: 1.25,
  height: 20,
  maxWidth: 20,
  padding: '5px !important',
  width: 20
}

const ShowHideButton = ({ show, toggleIsHidden, disabled, className }) => (
  <div className={className}>
    {show
      ? <MinusIconButton onClick={toggleIsHidden} disabled={disabled} sx={buttonSx} />
      : <PlusIconButton onClick={toggleIsHidden} disabled={disabled} sx={buttonSx} />}
  </div>
)

export default ShowHideButton
